
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/beautyawards2025/luckyreels",
      function () {
        return require("private-next-pages/beautyawards2025/luckyreels.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/beautyawards2025/luckyreels"])
      });
    }
  